import {
  CommentOutlined,
  FavoriteBorder,
} from "@mui/icons-material";
import { Icon } from "@mui/material";
import logoBranco from "../../assets/radar-logo-branco.png";
import { useEffect, useState } from "react";
import eventService from "../../services/EventService";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import canaisService from "../../services/CanaisService";
import { InstitutionalResponse, getInstitutional } from "services/PageService";
import FiltersPost from "components/posts/FiltersPost";
import { getEventsFilters } from "services/post/FilterService";
import placeholder from "images/placeholder-small.png";
import Pagination from "components/table/Pagination";

export const selectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    cursor: "pointer",
    borderRadius: "1.228rem",
    border: "1px solid #d8d6de",
    padding: "3px 10px",
    maxWidth: "340px",
    minWidth: "340px",
    "&:hover": {},
  }),
  menu: (provided: any) => ({
    ...provided,
    width: "auto", // Ajusta automaticamente a largura do menu de opções
    minWidth: "300px", // Define uma largura mínima para o menu de opções
  }),
};

export const selectThemeColors = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#cebab1", // for option hover bg-color
    primary: "#A27C6A", // for selected option bg-color
    neutral10: "#cebab1", // for tags bg-color
    neutral20: "#cebab1", // for input border-color
    neutral30: "#cebab1", // for input hover border-color
  },
});

const Events: React.FC = () => {
  const [eventos, setEventos] = useState([]);
  const [eventosPast, setEventosPast] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingEventosPast, setLoadingEventosPast] = useState(true);
  const [loadingEventos, setLoadingEventos] = useState(true);

  const [institutional, setInstitutional] = useState<InstitutionalResponse | null>(null);

  const [paginationDataFuture, setPaginationDataFuture] = useState<any>();
  const [paginationDataPast, setPaginationDataPast] = useState<any>();
  const [filtersData, setFiltersData] = useState<any>();

  const navigate = useNavigate();
  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;
  const [banner, setBanner] = useState("");

  const getEventosFuture = async (current_page = 1, per_page = 1000, filters : any = {}) => {
    setLoading(true); // start loading
    await eventService
      .getEventFuture({...filters, page: current_page, per_page: per_page})
      .then((response: any) => {
        setEventos(response.data.data);
        setLoadingEventos(false);

        setPaginationDataFuture({
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          per_page: response.data.per_page,
          total: response.data.total,
        });
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const getEventosPast = async (current_page = 1, per_page = 1000, filters : any = {}) => {
    setLoadingEventosPast(true); // start loading
    await eventService
      .getEventPast({...filters, page: current_page, per_page: per_page})
      .then((response: any) => {
        setEventosPast(response.data.data);
        setLoadingEventosPast(false);

        setPaginationDataPast({
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          per_page: response.data.per_page,
          total: response.data.total,
        });
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoadingEventosPast(false); // end loading
      });
  };

  const fetchData = async () => {
    try {
      const data = await getInstitutional(7);
      setInstitutional(data);
    } catch (error) {
      // Lidar com erros, se necessário
    }
  };

  useEffect(() => {
    if (institutional) {
      setBanner(
        `${urlBaseApi}/storage/images/institutional/banners/${
          institutional?.banners?.find((e) => e.name == "Banner eventos")
            ?.banner_path
        }`
      );
    }
  }, [institutional]);

  useEffect(() => {
    fetchData();
  }, []);

  const montarCard = () => {
    if (eventos.length > 0 && !loadingEventos) {
      return eventos.map((evento: any, index: any) => {
        const urlBase: any =
          process.env.REACT_APP_BACKEND_API_URL +
          "/storage/images/posts/events/logos";
        const ImageUrl: any = urlBase + `/${evento.logo_path}`;
        return (
          <div
            key={index}
            className="flex items-center h-56 bg-white dark:bg-gray-600 rounded-3xl border border-gray-200 dark:border-gray-400 px-4"
          >
            <img
              alt=""
              className="rounded-lg h-32 w-32 object-cover sm:h-48 sm:w-48 lg:h-48 lg:w-48 click"
              src={ImageUrl}
              onClick={() => navigate("/evento-detalhes/" + evento.id)}
              onError={(e) => (e.currentTarget.src = placeholder)}
            />
            <div className="flex flex-col w-full h-48 justify-between ml-4">
              <div className="flex flex-col gap-y-2">
                <p
                  onClick={() => navigate("/evento-detalhes/" + evento.id)}
                  className="text-sm sm:text-lg lg:text-xl text-left font-semibold cursor-pointer"
                >
                  {evento.name}
                </p>
                <span className="text-gray-400 text-sm">
                  {format(parseISO(evento.initial_date), "d 'de' MMMM, yyyy", {
                    locale: ptBR,
                  })}

                  {/* Sábado, 11 de novembro, São Paulo */}
                </span>
                <div className="flex gap-x-2">
                  {evento.address?.state && (
                    <span className="bg-primary-600 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                      {evento.address?.state}
                    </span>
                  )}
                  {evento.address?.city && (
                    <span className="bg-primary-400 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                      {evento.address?.city}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-between items-center">
                <div className="flex gap-x-2 flex-nowrap">
                  <button className="rounded-full h-8 px-6-new text-sm bg-primary-600 text-white hover:bg-primary-300 shadow-sm whitespace-nowrap">
                    <Icon
                      component={FavoriteBorder}
                      fontSize="small"
                      className="mr-2"
                    />
                    {evento?.likes_count ?? 0}
                  </button>
                  <button className="rounded-full h-8 px-6-new text-sm bg-primary-600 text-white hover:bg-primary-300 shadow-sm whitespace-nowrap">
                    <Icon
                      component={CommentOutlined}
                      fontSize="small"
                      className="mr-2"
                    />
                    {evento?.comments_count ?? 0}
                  </button>
                </div>

                {/* <div className="flex justify-center items-center h-10 w-10 bg-primary-600 rounded-full shadow-md hover:bg-primary-300 cursor-pointer">
                  <Icon
                    className="text-white"
                    component={BookmarkBorder}
                    fontSize="small"
                  />
                </div> */}
              </div>
            </div>
          </div>
        );
      });
    } else {
      return <div>Nenhum evento encontrado.</div>;
    }
  };

  const montarCardPast = () => {
    if (eventosPast.length > 0 && !loadingEventosPast) {
      return eventosPast.map((evento: any, index: any) => {
        const urlBase: any =
          process.env.REACT_APP_BACKEND_API_URL +
          "/storage/images/posts/events/logos";
        const ImageUrl: any = urlBase + `/${evento.logo_path}`;
        return (
          <div
            key={index}
            className="flex items-center h-56 bg-white dark:bg-gray-600 rounded-3xl border border-gray-200 dark:border-gray-400 px-4"
          >
            <img
              alt=""
              className="rounded-lg h-32 w-32 object-cover sm:h-48 sm:w-48 lg:h-48 lg:w-48 click"
              src={ImageUrl}
              onClick={() => navigate("/evento-detalhes/" + evento.id)}
              onError={(e) => (e.currentTarget.src = placeholder)}
            />
            <div className="flex flex-col w-full h-48 justify-between ml-4">
              <div className="flex flex-col gap-y-2">
                <p
                  onClick={() => navigate("/evento-detalhes/" + evento.id)}
                  className="text-sm sm:text-lg lg:text-xl text-left font-semibold cursor-pointer"
                >
                  {evento.name}
                </p>
                <span className="text-gray-400 text-sm">
                  {format(parseISO(evento.initial_date), "d 'de' MMMM, yyyy", {
                    locale: ptBR,
                  })}

                  {/* Sábado, 11 de novembro, São Paulo */}
                </span>
                <div className="flex gap-x-2">
                  {evento.address?.state && (
                    <span className="bg-primary-600 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                      {evento.address?.state}
                    </span>
                  )}
                  {evento.address?.city && (
                    <span className="bg-primary-400 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                      {evento.address?.city}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex w-full justify-between items-center">
                <div className="flex gap-x-2 flex-nowrap">
                  <button className="rounded-full h-8 px-6-new text-sm bg-primary-600 text-white hover:bg-primary-300 shadow-sm whitespace-nowrap">
                    <Icon
                      component={FavoriteBorder}
                      fontSize="small"
                      className="mr-2"
                    />
                    {evento?.likes_count ?? 0}
                  </button>
                  <button className="rounded-full h-8 px-6-new text-sm bg-primary-600 text-white hover:bg-primary-300 shadow-sm whitespace-nowrap">
                    <Icon
                      component={CommentOutlined}
                      fontSize="small"
                      className="mr-2"
                    />
                    {evento?.comments_count ?? 0}
                  </button>
                </div>



                {/* <div className="flex justify-center items-center h-10 w-10 bg-primary-600 rounded-full shadow-md hover:bg-primary-300 cursor-pointer">
                  <Icon
                    className="text-white"
                    component={BookmarkBorder}
                    fontSize="small"
                  />
                </div> */}
              </div>
            </div>
          </div>
        );
      });
    } else {
      return <div>Nenhum evento encontrado.</div>;
    }
  };

  // const handleFilters = (filters: any) => {
  //   setFiltersTmp(filters);
  //   getEventos(filters);
  // }

  const handleFilters = (filters: any) => {
    getEventosFuture(paginationDataFuture?.current_page ?? 1, 6, filters);
    getEventosPast(paginationDataPast?.current_page ?? 1, 6, filters);
  }

  const handlePaginationFutureChange = (page: any) => {
    getEventosFuture(page, 6, filtersData);
  };

  const handlePaginationPastChange = (page: any) => {
    getEventosPast(page, 6, filtersData);
  };

  return (
    <div className="flex flex-col items-center pt-5 p-1">
      
      <div
        className="flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-5xl py-44 brightness-100 text-white rounded-3xl">
          {institutional?.texts?.find((e) => e.name == "Titulo do banner")
            ?.text ?? ""}
        </span>
      </div>

      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt; <Link to={"/eventos"}>Eventos</Link>
      </span>

      <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] mt-20 mb-10">
        <div className="flex flex-col lg:flex-row text-justify items-center gap-10 p-2 bg-primary-50 dark:bg-gray-600 rounded-3xl">
          
          <div
            className="flex w-full text-justify"
            dangerouslySetInnerHTML={{
              __html:
                institutional?.texts?.find((e) => e.name == "Descrição eventos")
                  ?.text ?? "",
            }}
          ></div>

          <iframe
            className="shadow-2xl w-full sm:w-[30rem] lg:w-[50rem] h-[12rem] sm:h-[17.9rem] rounded-3xl lg:mr-[-10%]"
            width="1980"
            height="1024"
            src={
              institutional?.videos?.find((e) => e.name == "Video eventos")
                ?.video_path ?? ""
            }
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>

      <section>
        <div className="flex flex-col mb-10 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
          <div className="w-100">

            <FiltersPost 
              filtersData={filtersData}
              setFiltersData={setFiltersData}
              filters={['category', 'subcategory', 'country', 'state', 'city', 'search']} 
              handleFilters={handleFilters} 
              getFilters={getEventsFilters} 
            />

            {/* <div className="flex-row justify-end">
              <div className="flex flex-col lg:flex-row items-start lg:items-center justify-start lg:justify-between">
                <div className="flex gap-2 xl:gap-6">
                  <span className="text-sm md:text-base"></span>
                </div>
                
                <div className="flex gap-2 xl:gap-6 flex-wrap display-contet">
                  <div className="flex items-end gap-x-2 px-4 mt-6 bg-white dark:bg-gray-400 rounded-full border border-gray-200 w-full h-full flex flex-row items-center">
                    <input
                      className="text-black bg-transparent border-transparent w-full overflow-hidden resize-none focus:rounded-l-full"
                      maxLength={42}
                      placeholder="Procurar por..."
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <div
                      onClick={() => setSearch(searchValue)}
                      className="flex justify-center items-center h-9 w-10 bg-primary-600 rounded-full shadow-md hover:bg-opacity-70 cursor-pointer"
                    >
                      <Icon
                        className="text-white"
                        component={Search}
                        fontSize="medium"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <h2 className="mt-10 md:mt-5 pb-5 text-gray-600 font-semibold">
              Eventos Futuros
            </h2>
            <div className="mt-3">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5">
                {loading ? (
                  <div className="w-full spinner border-primary-600"></div>
                ) : eventos.length > 0 ? (
                  montarCard()
                ) : (
                  <div className="bg-primary-50 border rounded-3xl w-100 p-8">
                    Nenhum evento futuro encontrado
                  </div>
                )}
              </div>

              {
                !loading && eventos.length > 0 && (
                  <div className="mt-5 flex justify-start">
                    <Pagination pagination={paginationDataFuture} fetchData={(page: number) => handlePaginationFutureChange(page)} />
                  </div>
                )
              }
            </div>

            <h2 className="mt-20 mb-5 text-gray-600 font-semibold">
              Eventos Realizados
            </h2>
            <div className="mt-3">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5">
                {loadingEventosPast ? (
                  <div className="spinner border-primary-600"></div>
                ) : eventosPast.length > 0 ? (
                  montarCardPast()
                ) : (
                  <div className="bg-primary-50 border rounded-3xl w-100 p-8">
                    Nenhum evento encontrado
                  </div>
                )}
              </div>
              {
                !loadingEventosPast && eventosPast.length > 0 && (
                  <div className="mt-5 flex justify-start">
                    <Pagination pagination={paginationDataPast} fetchData={(page: number) => handlePaginationPastChange(page)} />
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </section>

      {/* <div className="mx-4 sm:mx-6 md:mx-8 lg:mx-10 xl:mx-12 2xl:mx-[16vw] flex flex-col sm:flex-row items-center my-20 gap-x-8">
        <div className="flex flex-1 flex-col gap-y-6">
          <p className="text-xl sm:text-2xl md:text-2xl lg:text-3xl text-left font-bold">
            Receba nossa Newsletter
          </p>
          <p className="text-sm sm:text-base md:text-base lg:text-lg text-left font-medium text-gray-400">
            Se inscrevendo você ficará por dentro de tudo que acontece na
            Comunidade Rardar
          </p>
          <div className="flex flex-col gap-y-3">
            <div className="flex items-center gap-x-4">
              <div className="flex justify-center items-center h-8 w-8 bg-primary-600 rounded-full shadow-md">
                <Icon
                  className="text-white"
                  component={ChevronRight}
                  fontSize="small"
                />
              </div>
              <p className="lg:text-lg text-left sm:text-base font-medium">
                Dicas
              </p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex justify-center items-center h-8 w-8 bg-primary-600 rounded-full shadow-md">
                <Icon
                  className="text-white"
                  component={ChevronRight}
                  fontSize="small"
                />
              </div>
              <p className="lg:text-lg text-left sm:text-base font-medium">
                Classificados
              </p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex justify-center items-center h-8 w-8 bg-primary-600 rounded-full shadow-md">
                <Icon
                  className="text-white"
                  component={ChevronRight}
                  fontSize="small"
                />
              </div>
              <p className="lg:text-lg text-left sm:text-base font-medium">
                Parcerias
              </p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex justify-center items-center h-8 w-8 bg-primary-600 rounded-full shadow-md">
                <Icon
                  className="text-white"
                  component={ChevronRight}
                  fontSize="small"
                />
              </div>
              <p className="lg:text-lg text-left sm:text-base font-medium">
                Descontos
              </p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex justify-center items-center h-8 w-8 bg-primary-600 rounded-full shadow-md">
                <Icon
                  className="text-white"
                  component={ChevronRight}
                  fontSize="small"
                />
              </div>
              <p className="lg:text-lg text-left sm:text-base font-medium">
                Conexões
              </p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex justify-center items-center h-8 w-8 bg-primary-600 rounded-full shadow-md">
                <Icon
                  className="text-white"
                  component={ChevronRight}
                  fontSize="small"
                />
              </div>
              <p className="lg:text-lg text-left sm:text-base font-medium">
                E Muito Mais!
              </p>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-400 rounded-full border border-gray-200 w-full h-full flex flex-row items-center gap-x-2 pr-1">
            <input
              className="text-black bg-transparent border-transparent w-full overflow-hidden resize-none focus:rounded-l-full"
              maxLength={42}
              placeholder="Insira seu E-Mail"
            />
            <div className="flex justify-center items-center h-9 w-10 bg-primary-600 rounded-full shadow-md hover:bg-opacity-70 cursor-pointer">
              <Icon
                className="text-white"
                component={ArrowRightAlt}
                fontSize="medium"
              />
            </div>
          </div>
        </div>

        <div className=" mt-2 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-[45rem] h-[30rem] flex items-center bg-[url(https://static-prod.adweek.com/wp-content/uploads/2023/07/bobbie-influencer-partner-2023.jpg)] bg-cover bg-primary-50 dark:bg-gray-300 rounded-3xl">
          <div className="flex items-center bg-primary-600 bg-opacity-60 w-full h-80 px-28">
            <div className="flex items-center justify-center bg-primary-600 bg-opacity-80 w-full h-40 gap-x-4">
              <img className="w-28 h-28" src={logoBranco} />
              <span className="text-white text-5xl [font-family:'Poppins-ExtraBold',Helvetica]">
                Radar & Você
              </span>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Events;
